import { useBooking } from "@/context/BookingContext";
import Reveal from "@/components/Reveal";
import { ArrowRight } from "lucide-react";

export default function CustomStyling() {
  const { openBooking } = useBooking();
  return (
    <section data-testid="custom-styling" className="bg-[#FAF8F5] text-[#1C1917] py-24 lg:py-36">
      <div className="max-w-[1100px] mx-auto px-5 sm:px-10">
        <div className="bg-[#7A8B7B]/10 border border-[#7A8B7B]/20 rounded-[2rem] px-6 sm:px-14 py-16 text-center">
          <Reveal>
            <span className="text-[#7A8B7B] text-[11px] tracking-[0.35em] uppercase font-semibold">First Time?</span>
            <h2 className="font-serif text-5xl sm:text-7xl font-medium leading-[0.95] tracking-tight mt-5">
              Don't know what to book? <span className="italic text-[#C5B382]">You don't need to.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-7 text-lg sm:text-xl text-[#1C1917]/70 leading-relaxed max-w-2xl mx-auto">
              “Tell me the look you love and I'll help choose a style that complements your eye
              shape, natural lashes and features.”
            </p>
            <button
              data-testid="custom-book"
              onClick={() => openBooking()}
              className="group mt-9 inline-flex items-center gap-3 bg-[#1C1917] hover:bg-[#C5B382] text-white hover:text-[#1C1917] text-[11px] font-semibold tracking-[0.2em] uppercase px-9 py-4 rounded-full transition-colors duration-300"
            >
              Book Your Appointment
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
